export default function InProgress() {
    return (
        <section className={`container-custom text-center`}>
            <h1>Страница находится в разработке</h1>
        </section>
    )
}